import React, { useContext } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Text, useTheme } from 'react-native-paper';
import { ThemePreferencesContext } from '../../contexts/ThemeContext';

type EditCourseScreenProps = { navigation: any; route: any };

const EditCourseScreen = ({ navigation }: EditCourseScreenProps) => {
  const theme = useTheme();
  const { toggleTheme, isDarkMode } = useContext(ThemePreferencesContext);
  return (
    <View style={[styles.container, { backgroundColor: theme.colors.background }]}>
      <Text variant="headlineSmall" style={{ color: theme.colors.primary }}>Course metadata is managed centrally</Text>
      <Text style={[styles.message, { color: theme.colors.onSurface }]}>
        Course metadata and offerings are synchronized by the administrator. Client-side editing is disabled on Spark.
      </Text>
      <Button mode="contained" onPress={() => navigation.goBack()} style={styles.button}>
        Go back
      </Button>
      <Button mode="text" onPress={toggleTheme} textColor={theme.colors.primary}>
        {isDarkMode ? 'Use light theme' : 'Use dark theme'}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', padding: 24 },
  message: { marginTop: 16, lineHeight: 22 },
  button: { marginTop: 24 },
});

export default EditCourseScreen;
